import { render } from "./VolumeIcon.vue?vue&type=template&id=43f0135f"
import script from "./VolumeIcon.vue?vue&type=script&lang=js"
export * from "./VolumeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__